import React, { Component } from 'react'
import { connect } from 'react-redux'
import cn from 'classnames'
import { Link } from 'react-router-dom'
import { injectIntl } from 'react-intl'
import MenuIcon from '@material-ui/icons/Menu'
import MenuCloseIcon from '@material-ui/icons/Close'
import { Button, Typography } from '@material-ui/core'
import FeedbackWidget from 'widgets/Feedback'
import { toggleMobileMenu } from 'reducers/layout/reducer'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'
import NavLeftList from './NavLeftList'
import NavRightList from './NavRightList'
import 'styles/app/layout/app.scss'

class Header extends Component {
  menuToggle = () => {
    this.props.toggleMobileMenu()
    this.props.onClick()
  }

  render() {
    const {
      isOpenMobileMenu,
      currentAppName,
      licensee: { logoUrl, name },
    } = this.props
    const licenseeLogo = !logoUrl ? '' : logoUrl
    const logoAlt = `${name} logo`
    const brandClasses = cn('brand mobile-cut-logo', {
      licenseeLogo,
    })
    const isMobileResolution = ifWindowWidthLessThan(992)

    return (
      <section className="app-header">
        <div className="app-header-inner">
          {isMobileResolution && (
            <>
              <Button
                disableRipple
                className="header-icon toggle-sidebar-btn"
                onClick={this.menuToggle}>
                {isOpenMobileMenu ? <MenuCloseIcon /> : <MenuIcon />}
              </Button>
              <Typography variant="h5" className="module-title-mobile">
                {currentAppName}
              </Typography>
            </>
          )}
          <div className={brandClasses}>
            <Link to="/">
              <img src="/assets/images/mobile-ecto-logo.svg" alt="ecto logo" />
            </Link>
          </div>
          {!isMobileResolution && (
            <div className="top-nav-right">
              {licenseeLogo && (
                <div className="logo-wrap">
                  <img src={licenseeLogo} alt={logoAlt} />
                </div>
              )}
              <NavLeftList />
              <NavRightList />
              <FeedbackWidget />
            </div>
          )}
        </div>
      </section>
    )
  }
}

const enhance = connect(
  state => ({
    isOpenMobileMenu: state.getIn(['layout', 'isOpen']),
    licensee: state.getIn(['profile', 'profile', 'licensee']),
    applications: state.getIn(['profile', 'profile', 'applications']),
    currentAppName: state.getIn(['profile', 'currentAppName']),
  }),
  {
    toggleMobileMenu,
  },
)

export default enhance(injectIntl(Header))
